export interface VimeoVideoPlayerProps {
    id: string;
    style?: React.CSSProperties;
}

export function VimeoVideoPlayer({ id, style }: VimeoVideoPlayerProps) {
    return (
        <iframe
            src={`https://player.vimeo.com/video/${id}`}
            style={{ border: 'none', height: '100%', ...style }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
        />
    );
}
